import { View, StyleSheet } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomTextInput from "../../../common/general/CustomTextInput/CustomTextInput";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import { Remove } from "../../../svgs/CustomCoursework";
import { SparkleBlue } from "../../../svgs/common";

const ObjectivesWithCriteriaList = ({
  objectivesWithCriteria = [],
  onRemoveObjectiveWithCriteria,
  onUpdateCriteria,
  onRegenerateCriteria,
  disabled = false,
  isGeneratingCriteria = false,
  isRegeneratingCriteriaForObjective = {},
}) => {
  return (
    <View style={styles.objectivesList}>
      {objectivesWithCriteria.map((item, index) => (
        <View key={index} style={styles.objectiveWithCriteriaItem}>
          <View style={styles.objectiveHeader}>
            <CustomText
              text={item.objective}
              size="s"
              weight="bold"
              useTranslationText={false}
              style={styles.objectiveText}
            />
            <View style={styles.buttonContainer}>
              {/* New Regenerate Button */}
              <CustomButton
                text="Generate Eval Criteria"
                onPress={() => onRegenerateCriteria(index, item)}
                loading={isRegeneratingCriteriaForObjective[index]}
                disabled={disabled || isGeneratingCriteria || isRegeneratingCriteriaForObjective[index]}
                styleType="transparent"
                size="xs"
                leftIcon={<SparkleBlue width={14} height={14} style={{ marginRight: 2 }} />}
                textStyle={{ color: "#3E68FE", fontSize: 12 }}
              />
              <CustomButton
                styleType="transparent"
                leftIcon={<Remove />}
                size="s"
                onPress={() => onRemoveObjectiveWithCriteria(index)}
                disabled={disabled || isGeneratingCriteria}
              />
            </View>
          </View>

          <View style={styles.criteriaContainer}>
            {isGeneratingCriteria || isRegeneratingCriteriaForObjective[index] ? (
              <CustomTextInput
                value="Loading..."
                multiline
                style={[styles.criteriaInput, styles.loadingInput]}
                editable={false}
              />
            ) : item.evalCriteria && item.evalCriteria.length > 0 ? (
              item.evalCriteria.map((criteria, criteriaIndex) => (
                <CustomTextInput
                  key={criteriaIndex}
                  value={criteria}
                  onChangeText={(text) => {
                    const updatedCriteria = [...item.evalCriteria];
                    updatedCriteria[criteriaIndex] = text;
                    onUpdateCriteria(index, updatedCriteria);
                  }}
                  placeholder="Evaluation criteria"
                  multiline
                  style={styles.criteriaInput}
                  editable={!disabled}
                />
              ))
            ) : (
              <CustomTextInput
                value=""
                placeholder="No evaluation criteria yet. Generate criteria or add them manually."
                multiline
                style={styles.criteriaInput}
                editable={!disabled}
                onChangeText={(text) => {
                  const updatedCriteria = [text];
                  onUpdateCriteria(index, updatedCriteria);
                }}
              />
            )}
          </View>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  objectivesList: {
    marginTop: 8,
  },
  objectiveWithCriteriaItem: {
    marginBottom: 12,
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#E5E7EB",
    overflow: "hidden",
  },
  objectiveHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 8,
    paddingHorizontal: 16,
    backgroundColor: "#EAECF0",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  objectiveText: {
    flex: 1,
    fontSize: 14,
    fontWeight: 600,
  },
  buttonContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  criteriaContainer: {
    padding: 12,
  },
  criteriaInput: {
    backgroundColor: "#F9FAFB",
    borderRadius: 6,
    marginBottom: 8,
    minHeight: 80,
    textAlignVertical: "top",
  },
  loadingInput: {
    backgroundColor: "#F0F0F0",
    color: "#667085",
    fontStyle: "italic",
  },
});

export default ObjectivesWithCriteriaList;
